export default __webpack_public_path__ + "static/media/indogo-screenshot-03.035c012d.png";